import getAxiosAuthHeaders from '../../../functions/getAxiosAuthHeaders';
import api from '../../../apis/api';

const deleteJobAttachment = async (jobId, attachment) => {
  const { attachmentId, attachmentName } = attachment;
  return api.delete(`job/${jobId}/attachment/${attachmentId}`, {
    params: { attachmentName },
    headers: await getAxiosAuthHeaders(),
  });
};

export default deleteJobAttachment;
